/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {GetPropValue, GetPropAsPx} from './_helpers.tsx';
import ChangeStyleTheme from '../../../core/ChangeStyleTheme';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    a: "a",
    h2: "h2",
    code: "code",
    strong: "strong",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    h3: "h3",
    pre: "pre"
  }, _provideComponents(), props.components), {VisibilityByTheme} = _components;
  if (!VisibilityByTheme) _missingMdxReference("VisibilityByTheme", false);
  if (!VisibilityByTheme.Name) _missingMdxReference("VisibilityByTheme.Name", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h1, {
      children: ["Line Height for ", _jsx(VisibilityByTheme.Name, {})]
    }), "\n", _jsx(ChangeStyleTheme, {
      label: "Change the brand:",
      bottom: "large"
    }), "\n", _jsxs(_components.p, {
      children: ["For details about what values Typographic elements do use, have a look at the ", _jsx(_components.a, {
        href: "/quickguide-designer/fonts#typographic-elements",
        children: "Fonts & Typography"
      }), " documentation."]
    }), "\n", _jsxs(_components.h2, {
      children: ["Default ", _jsx(_components.code, {
        children: "line-height"
      }), " ", _jsx(_components.strong, {
        children: "rem"
      }), " table"]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Pixel"
          }), _jsx(_components.th, {
            children: "Type"
          }), _jsx(_components.th, {
            children: "Rem"
          }), _jsx(_components.th, {
            children: "CSS variable / property"
          }), _jsx(_components.th, {
            children: "CSS Classname"
          }), _jsx(_components.th, {
            children: "Info"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: GetPropAsPx('--line-height-x-small')
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "x-small"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: GetPropValue('--line-height-x-small')
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--line-height-x-small"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: ".dnb-t__line-height--x-small"
            })
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: GetPropAsPx('--line-height-small')
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "small"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: GetPropValue('--line-height-small')
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--line-height-small"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: ".dnb-t__line-height--small"
            })
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: GetPropAsPx('--line-height-basis')
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "basis"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: GetPropValue('--line-height-basis')
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--line-height-basis"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: ".dnb-t__line-height--basis"
            })
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: GetPropAsPx('--line-height-lead')
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "lead"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: GetPropValue('--line-height-lead')
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--line-height-lead"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: ".dnb-t__line-height--lead"
            })
          }), _jsxs(_components.td, {
            children: ["Unique line-height for ", _jsx(_components.code, {
              children: "<Lead>"
            }), "."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: GetPropAsPx('--line-height-medium')
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "medium"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: GetPropValue('--line-height-medium')
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--line-height-medium"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: ".dnb-t__line-height--medium"
            })
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: GetPropAsPx('--line-height-large')
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "large"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: GetPropValue('--line-height-large')
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--line-height-large"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: ".dnb-t__line-height--large"
            })
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: GetPropAsPx('--line-height-x-large')
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "x-large"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: GetPropValue('--line-height-x-large')
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--line-height-x-large"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: ".dnb-t__line-height--x-large"
            })
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: GetPropAsPx('--line-height-xx-large')
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "xx-large"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: GetPropValue('--line-height-xx-large')
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--line-height-xx-large"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: ".dnb-t__line-height--xx-large"
            })
          }), _jsxs(_components.td, {
            children: ["Same as ", _jsx(_components.code, {
              children: "x-large"
            })]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      children: "Code Editor Extensions"
    }), "\n", _jsxs(_components.p, {
      children: ["You may be interested to install an ", _jsx(_components.a, {
        href: "/uilib/helpers/tools/#code-editor-extensions",
        children: "Eufemia code editor extension"
      }), " that allows you to quickly auto complete the correct ", _jsx(_components.code, {
        children: "line-height"
      }), "."]
    }), "\n", _jsxs(_components.h2, {
      children: ["Additional ", _jsx(_components.code, {
        children: "line-height"
      }), " ", _jsx(_components.strong, {
        children: "em"
      }), " table"]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Pixel"
          }), _jsx(_components.th, {
            children: "Type"
          }), _jsx(_components.th, {
            children: "Em"
          }), _jsx(_components.th, {
            children: "Custom Property"
          }), _jsx(_components.th, {
            children: "Info"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "16px"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "xx-small--em"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: GetPropValue('--line-height-xx-small--em')
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--line-height-xx-small--em"
            })
          }), _jsx(_components.td, {})]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "24px"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "basis--em"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: GetPropValue('--line-height-basis--em')
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--line-height-basis--em"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "*"
            })
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "*"
      }), " For example: if we sum 1.33333333333*18 we get 24. Browsers do round CSS values, so we do not need all the decimal numbers for now."]
    }), "\n", _jsx(_components.h3, {
      children: "How to use the line heights (CSS)"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-css",
        children: "/* I have a default height */\n.dnb-p {\n  line-height: var(--line-height-basis); /* 1.5rem = 24px (in Ui theme) */\n}\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
